import { TriangleAlert } from "lucide-react";

import {
  AlertDescription,
  AlertTitle,
  Alert as ShadAlert,
} from "@/components/ui/alert";

export function Alert() {
  return (
    <div className="grid w-full max-w-xl items-start gap-4">
      <ShadAlert variant={"warning"}>
        <TriangleAlert />
        <AlertTitle>Missing Information</AlertTitle>
        <AlertDescription>
          Please fill in the missing information for the student to convert the
          batch
        </AlertDescription>
      </ShadAlert>
    </div>
  );
}
